<template>
  <div>
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
    />
    <div v-if="hasPermissionSearchMode">
      <search-mode :actions.sync="searchModeActions" />
      <div v-if="providersTrayMode.rendered">
        <providers-tray v-show="providersTrayMode.active" />
      </div>
      <div v-if="providersApprovalTrayMode.rendered">
        <providers-approval-tray
          v-show="providersApprovalTrayMode.active"
          v-model="providersApprovalTrayModel"
        />
      </div>
    </div>
    <providers-tray v-else />
  </div>
</template>

<script>
import { SearchMode, ProvidersTray, ProvidersApprovalTray } from './components';
import PageHeader from 'PageHeader';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
import storeModuleNames from '@/utils/constants/storeModuleNames.js';
import { getDefaultSearch as _getDefaultSearch } from '@/services/provider/provider.api.js';

const PROVIDER_MANAGEMENT_ROUTE_NAME = 'ProviderManagement';

export default {
  name: 'ProviderMain',
  mixins: [storeMixin],
  components: {
    SearchMode,
    ProvidersTray,
    ProvidersApprovalTray,
    PageHeader,
  },
  data: () => ({
    moduleName: storeModuleNames.ProviderModuleName,
    searchModeActions: [
      {
        id: 'providersTray',
        text: 'Bandeja de proveedores',
        value: 1,
        active: false,
        rendered: false,
      },
      {
        id: 'providersApprovalTray',
        text: 'Bandeja para aprobación de proveedores',
        value: 2,
        active: false,
        rendered: false,
      },
    ],
    providersApprovalTrayModel: {
      fiscalYear: null,
      providerType: null,
      provider: null,
      status: null,
      documentStatus: null,
      documentType: null,
      documentExpired: null,
      requestNumber: null,
      dateRange: [],
      orderByDocumentExpirationDate: false,
      orderByLastDate: false,
    },
  }),
  async mounted() {
    await this.getDefaultSearch();
  },
  computed: {
    headerConfig() {
      return {
        title: 'Proveedores',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Proveedores'],
      };
    },
    headerActionsConfig() {
      return [
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus pr-2',
          variant: 'success ml-0',
          visible: this.hasAddPermission,
          click: () => this.onAddHandler(),
        },
      ];
    },
    hasPermissionSearchMode() {
      return this.userHasPermissions('rempro.providers.trays.mode');
    },
    hasAddPermission() {
      return this.userHasPermissions('menu.rempro.providers.view.addprovider');
    },
    providersTrayMode() {
      return this.searchModeActions[0];
    },
    providersApprovalTrayMode() {
      return this.searchModeActions[1];
    },
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async getDefaultSearch() {
      if (this.providersTrayMode.active) {
        this.providersApprovalTrayMode.rendered = false;
        this.providersApprovalTrayMode.active = false;
        return;
      }
      if (this.providersApprovalTrayMode.active) {
        this.providersTrayMode.rendered = false;
        this.providersTrayMode.active = false;
        return;
      }
      if (!this.hasPermissionSearchMode) {
        this.providersTrayMode.rendered = true;
        this.providersTrayMode.active = true;
        return;
      }
      const { data } = await _getDefaultSearch();
      if (!data) {
        this.providersTrayMode.rendered = true;
        this.providersTrayMode.active = true;
        return;
      }
      let defaultTab = 0;

      let { startMonth, endMonth, defaultTabValue } = data;
      let currentMonth = new Date().getMonth() + 1;
      if (startMonth > endMonth) {
        endMonth += 12;
        currentMonth += 12;
      }
      if (currentMonth >= startMonth && currentMonth <= endMonth)
        defaultTab = defaultTabValue - 1;

      this.searchModeActions[defaultTab].active = true;
      this.searchModeActions[defaultTab].rendered = true;
    },
    onAddHandler() {
      this.$router.push({
        name: PROVIDER_MANAGEMENT_ROUTE_NAME,
      });
    },
  },
};
</script>
